module.exports = __webpack_public_path__ + "img/gg.98f67a6f.svg";